import { Popover } from 'antd';
import React from 'react';
import styles from './style.module.scss';

const QuestionPopover = (props: { content: string }) => {
	return (
		<Popover
			content={props.content}
			overlayClassName={styles.container}
			placement="bottomRight"
		>
			<img src={require('./question_mark.png')} className={styles.question_icon} />
		</Popover>
	);
};

export default QuestionPopover;
